var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalDeleteImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2669 81.6C16.2669 84.0046 17.2221 86.3108 18.9224 88.0111C20.6228 89.7114 22.9289 90.6667 25.3335 90.6667H70.6669C73.0715 90.6667 75.3776 89.7114 77.078 88.0111C78.7783 86.3108 79.7335 84.0046 79.7335 81.6V27.2H88.8002V18.1333H70.6669V9.06667C70.6669 6.66204 69.7116 4.35589 68.0113 2.65556C66.311 0.955235 64.0048 0 61.6002 0H34.4002C31.9956 0 29.6894 0.955235 27.9891 2.65556C26.2888 4.35589 25.3335 6.66204 25.3335 9.06667V18.1333H7.2002V27.2H16.2669V81.6ZM34.4002 9.06667H61.6002V18.1333H34.4002V9.06667ZM29.8669 27.2H70.6669V81.6H25.3335V27.2H29.8669Z",
    fill: "#2795AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4004 36.2666H43.4671V72.5333H34.4004V36.2666ZM52.5337 36.2666H61.6004V72.5333H52.5337V36.2666Z",
    fill: "#2795AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalDeleteImg);
export default __webpack_public_path__ + "static/media/modal-delete-img.26531b30aa410579b502a046235f62e3.svg";
export { ForwardRef as ReactComponent };